import CustomTemplateInteractiveEditor from "./customTemplateInteractiveEditor.container";
export default CustomTemplateInteractiveEditor;
